<template>
  <section :class="['shop-variants', { 'shop-variants--readonly': readonly }]">
    <div class="shop-variants__items">
      <ButtonComponent
        v-for="(item, index) of items"
        :key="item.name"
        class="shop-variants__item"
        :class="{
          'shop-variants__item--selected': selected === index,
        }"
        @click="$emit('select', item.internalId)"
      >
        <div v-if="selected === index" class="shop-variants__item__icon">
          <Icon v-bind="icon" />
        </div>
        <img
          v-if="item.image"
          :src="item.image.url"
          :alt="item.name"
          class="shop-variants__image"
        />
        <span v-else>{{ item.name.slice(0, 1).toUpperCase() }}</span>
      </ButtonComponent>
    </div>
    <div class="shop-variants__details">
      <h3>{{ title }}</h3>
      <slot v-if="description" name="description" :current="current">
        <span v-html="description" />
      </slot>
    </div>
  </section>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import Icon from '@kvass/vue2-icon'

export default {
  name: 'Variants',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    category: String,
    readonly: Boolean,
  },
  computed: {
    icon() {
      if (this.readonly)
        return { icon: 'fa-pro-solid:lock-alt', size: 'sm', style: 'translate: 0 -1px' }
      return { icon: 'fa-pro-solid:check' }
    },
    title() {
      return this.current.name
    },
    description() {
      return this.current.description || this.$slots.description
    },
    selected() {
      if (this.value && this.value.value) {
        return this.items.findIndex(item => item.internalId === this.value.value)
      }
      return this.items.findIndex(item => item.isDefault)
    },
    current() {
      return this.items[this.selected]
    },
  },
  components: {
    ButtonComponent,
    Icon,
  },
}
</script>

<style lang="scss">
.shop-variants {
  --color: #1d56d8;
  --color-accent: #102537;

  &--readonly {
    pointer-events: none;

    .shop-variants__item:not(.shop-variants__item--selected) {
      opacity: 0.6;
    }
  }

  &__items {
    display: flex;
    padding: 0;
    margin: 0;
    gap: 0.5rem;
    flex-wrap: wrap;
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1rem;
  }

  &__item {
    border: 2px solid transparent;
    position: relative;
    border-radius: var(--border-radius) !important;

    &--selected {
      border-color: var(--color-accent);
    }

    &__icon {
      z-index: 1;
      position: absolute;
      top: -6px;
      right: -6px;
      color: white;
      width: 20px;
      height: 20px;
      background-color: var(--color-accent);
      border-radius: 20rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8em;
    }
  }

  &__details {
    h3 {
      font-weight: bold;
      margin-top: 1rem;
      font-size: 1rem;
    }

    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }

  &__image {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: calc(var(--border-radius) / 2);
  }
}
</style>
